import { render, staticRenderFns } from "./ClearCache.vue?vue&type=template&id=a1b58da6&scoped=true"
import script from "./ClearCache.vue?vue&type=script&lang=js"
export * from "./ClearCache.vue?vue&type=script&lang=js"
import style0 from "./ClearCache.vue?vue&type=style&index=0&id=a1b58da6&prod&lang=less&scoped=true"
import style1 from "./ClearCache.vue?vue&type=style&index=1&id=a1b58da6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b58da6",
  null
  
)

export default component.exports